import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoDocumentosDocumentoComponent (FinancesPosicionbancariaPrestamoDocumento) {
  var $ctrl = this

  $ctrl.abrir = abrir
  $ctrl.eliminando = false
  $ctrl.eliminar = eliminar
  $ctrl.src = null

  function abrir () {
    $ctrl.src = FinancesPosicionbancariaPrestamoDocumento.get($ctrl.data.id_empresa, $ctrl.data.id_cuenta, $ctrl.data.id_prestamo, $ctrl.data.indice)
  }

  function eliminar (data) {
    $ctrl.eliminando = false

    if (data)
      $ctrl.onDelete({$event: {data: data}})
  }
}

module.component('financesPosicionbancariaPrestamoDocumentosDocumento', {
  controller: FinancesPosicionbancariaPrestamoDocumentosDocumentoComponent,
  template,
  bindings: {
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/documentos/documento/component.js